const n = (t) => t != null, s = (t) => typeof t == "function", o = (t) => typeof t == "number" || /^\d+(\.\d+)?$/.test(t), i = (t) => t !== null && typeof t == "object";
function r(t) {
  return t = t.replace(/[^-|\d]/g, ""), /^((\+86)|(86))?(1)\d{10}$/.test(t) || /^0[0-9-]{10,13}$/.test(t);
}
const c = (t) => {
  if (!t)
    return !1;
  for (const e in t)
    return !1;
  return !0;
}, f = (t) => /^\w+([+-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(t);
export {
  n as isDef,
  f as isEmail,
  c as isEmptyObject,
  s as isFunction,
  r as isMobile,
  o as isNumeric,
  i as isObject
};
